var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-info"},[_c('v-icon',{staticClass:"ma-2 mt-1",attrs:{"color":"primary"}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"text-subtitle-3"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }